function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "live_inline_svg__Component_16_4",
  "data-name": "Component 16 \\u2013 4",
  transform: "translate(9 8.999)"
}, /*#__PURE__*/React.createElement("path", {
  id: "live_inline_svg__Subtraction_87",
  "data-name": "Subtraction 87",
  d: "M-2980.161 4693.351a13.015 13.015 0 01-13-13 13.016 13.016 0 0113-13 13.016 13.016 0 0113 13 13.015 13.015 0 01-13 13zm5.333-19.312a1.017 1.017 0 00-.706.283 1 1 0 000 1.4 6.5 6.5 0 011.919 4.628 6.5 6.5 0 01-1.919 4.626 1 1 0 000 1.4.978.978 0 00.7.287.979.979 0 00.7-.287 8.44 8.44 0 002.493-6.008 8.483 8.483 0 00-2.493-6.044.971.971 0 00-.693-.286zm-10.653 0a1.02 1.02 0 00-.706.283 8.462 8.462 0 00-2.492 6.027 8.52 8.52 0 002.51 6.025.982.982 0 00.7.287.981.981 0 00.7-.287.992.992 0 00-.018-1.4 6.524 6.524 0 01-1.92-4.626 6.5 6.5 0 011.92-4.628 1.007 1.007 0 000-1.4.973.973 0 00-.693-.282zm8.169 2.478a1 1 0 00-.7.281.99.99 0 00-.018 1.4 3.024 3.024 0 01.9 2.153 3.022 3.022 0 01-.9 2.151 1 1 0 00.018 1.4.986.986 0 00.7.287.987.987 0 00.7-.287 4.987 4.987 0 001.47-3.55 4.967 4.967 0 00-1.47-3.534.961.961 0 00-.699-.302zm-5.695 0a1.017 1.017 0 00-.706.284 4.988 4.988 0 00-1.47 3.551 4.992 4.992 0 001.47 3.55.987.987 0 00.7.287.988.988 0 00.7-.287 1.006 1.006 0 000-1.4 3.025 3.025 0 01-.9-2.151 3.027 3.027 0 01.9-2.153.948.948 0 00.3-.681.99.99 0 00-.3-.717.972.972 0 00-.693-.287zm2.845 2.329a1.508 1.508 0 00-1.507 1.506 1.508 1.508 0 001.507 1.505 1.508 1.508 0 001.507-1.505 1.508 1.508 0 00-1.506-1.51z",
  transform: "translate(2993.161 -4667.349)",
  fill: "#ff4182"
}), /*#__PURE__*/React.createElement("g", {
  id: "live_inline_svg__Ellipse_264",
  "data-name": "Ellipse 264",
  transform: "translate(0 .001)",
  fill: "none",
  stroke: "#ff4182",
  strokeWidth: 9,
  opacity: 0.4
}, /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 13,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 17.5
})));

function SvgLiveinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44"
  }, props), _ref);
}

export default SvgLiveinline;